import { render, staticRenderFns } from "./activity-record.vue?vue&type=template&id=73c642d0&scoped=true&"
import script from "./activity-record.vue?vue&type=script&lang=js&"
export * from "./activity-record.vue?vue&type=script&lang=js&"
import style0 from "./activity-record.vue?vue&type=style&index=0&id=73c642d0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c642d0",
  null
  
)

export default component.exports